(function(){
"use strict";
function boot(){
  const blocks=document.querySelectorAll('[data-ljx-globe]:not([data-earth-ready])');
  blocks.forEach(function(box){
    if(!window.THREE){let trials=0;const t=setInterval(function(){if(window.THREE){clearInterval(t);init(box)}else if(++trials>45){clearInterval(t);box.setAttribute('data-earth-error','library-unavailable')}},200);return}init(box)
  });
}
function init(box){
  if(box.hasAttribute('data-earth-ready')||!window.THREE)return;
  box.setAttribute('data-earth-ready','1');
  const T=window.THREE, mount=box.querySelector('[data-ljx-canvas]');
  const w=()=>Math.max(300,mount.clientWidth), h=()=>Math.max(300,mount.clientHeight);
  let renderer;
  try{renderer=new T.WebGLRenderer({alpha:true,antialias:true,powerPreference:'low-power'})}
  catch(e){box.setAttribute('data-earth-error','webgl-unavailable');return}
  renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,1.8));
  renderer.setSize(w(),h(),false);
  renderer.outputEncoding=T.sRGBEncoding;
  renderer.setClearColor(0x000000,0);
  mount.appendChild(renderer.domElement);
  const scene=new T.Scene(), camera=new T.PerspectiveCamera(36,w()/h(),0.1,100);camera.position.set(0,0,5.8);
  const group=new T.Group();scene.add(group);
  const surface=new T.Mesh(new T.SphereGeometry(1.62,88,60),new T.MeshPhongMaterial({color:0xe0f2e9,shininess:10,specular:0x244d4d}));
  group.add(surface);
  const ambience=new T.AmbientLight(0xffffff,.77);scene.add(ambience);
  const sun=new T.DirectionalLight(0xfff8dd,1.35);sun.position.set(-4,3,5);scene.add(sun);
  const fill=new T.DirectionalLight(0x9fc7e9,.5);fill.position.set(5,-2,-4);scene.add(fill);
  const atmosphere=new T.Mesh(new T.SphereGeometry(1.705,64,48),new T.MeshBasicMaterial({color:0x8be6d3,transparent:true,opacity:.07,side:T.BackSide,depthWrite:false}));group.add(atmosphere);
  // Geographic points align with the equirectangular Earth texture used by Three.js.
  function v(lat,lon,r){const a=lat*Math.PI/180,b=lon*Math.PI/180;return new T.Vector3(Math.cos(a)*Math.cos(b),Math.sin(a),-Math.cos(a)*Math.sin(b)).multiplyScalar(r||1.62)}
  const origin=[25.3176,82.9739];
  const destinations=[
    {name:"Sodepur, West Bengal, India",lat:22.69,lon:88.39,last:true},
    {name:"Hyderabad, Telangana, India",lat:17.385,lon:78.4867},
    {name:"Bengaluru, Karnataka, India",lat:12.9716,lon:77.5946},
    {name:"Yokohama, Kanagawa, Japan",lat:35.4437,lon:139.638},
    {name:"Udaipur, Rajasthan, India",lat:24.5854,lon:73.7125},
    {name:"Chennai, Tamil Nadu, India",lat:13.0827,lon:80.2707},
    {name:"Gurugram, Haryana, India",lat:28.4595,lon:77.0266},
    {name:"Kolkata, West Bengal, India",lat:22.5726,lon:88.3639}
  ];
  function arcPoint(dest,t,radius){
    let a=v(origin[0],origin[1],1),b=v(dest.lat,dest.lon,1);
    return a.lerp(b,t).normalize().multiplyScalar(radius+(Math.sin(t*Math.PI)*(.14+Math.min(.23,Math.abs(dest.lon-origin[1])*.004))));
  }
  const courier=[];
  const lineMat=(c)=>new T.LineBasicMaterial({color:c,transparent:true,opacity:.73,depthWrite:false});
  const geoPin=new T.SphereGeometry(.027,12,8);
  const originPoint=new T.Mesh(new T.SphereGeometry(.047,16,12),new T.MeshBasicMaterial({color:0xe4fcae}));originPoint.position.copy(v(...origin,1.648));group.add(originPoint);
  // Blue points are illustrative international locations, not recorded orders.
  // Keep the original destination list and all geocoded Indian order pins unchanged.
  const showcaseDestinations=[
    {name:"Kuala Lumpur, Malaysia",lat:3.1390,lon:101.6869,showcase:true},
    {name:"George Town, Penang, Malaysia",lat:5.4141,lon:100.3288,showcase:true},
    {name:"Johor Bahru, Malaysia",lat:1.4927,lon:103.7414,showcase:true},
    {name:"Berlin, Germany",lat:52.5200,lon:13.4050,showcase:true},
    {name:"Frankfurt, Germany",lat:50.1109,lon:8.6821,showcase:true},
    {name:"Munich, Germany",lat:48.1351,lon:11.5820,showcase:true},
    {name:"London, United Kingdom",lat:51.5074,lon:-0.1278,showcase:true},
    {name:"Manchester, United Kingdom",lat:53.4808,lon:-2.2426,showcase:true},
    {name:"Birmingham, United Kingdom",lat:52.4862,lon:-1.8904,showcase:true}
  ];
  destinations.push(...showcaseDestinations);
  destinations.forEach((d,i)=>{
    const pts=[];for(let k=0;k<=55;k++)pts.push(arcPoint(d,k/55,1.648));
    const routeMaterial=lineMat(d.last?0xeaff91:i===7?0x81f4e4:0xb6dea4);
    const line=new T.Line(new T.BufferGeometry().setFromPoints(pts),routeMaterial);group.add(line);
    const p=new T.Mesh(d.last?new T.SphereGeometry(.049,20,12):geoPin,new T.MeshBasicMaterial({color:d.last?0xe9ffa2:0xd4e8cf,transparent:true,opacity:.97}));p.position.copy(v(d.lat,d.lon,1.661));group.add(p);
    const moving=new T.Mesh(new T.SphereGeometry(d.last?.034:.025,12,8),new T.MeshBasicMaterial({color:d.last?0xfffaaa:0x99f7dd}));group.add(moving);courier.push({moving,d,i});
    if(d.last){
      const ring=new T.Mesh(new T.RingGeometry(.058,.078,32),new T.MeshBasicMaterial({color:0xe5ffa7,transparent:true,opacity:.78,side:T.DoubleSide,depthWrite:false}));
      ring.position.copy(v(d.lat,d.lon,1.678));ring.quaternion.setFromUnitVectors(new T.Vector3(0,0,1),v(d.lat,d.lon,1).normalize());group.add(ring);courier[courier.length-1].ring=ring;
    }
  });
  // Historical destination showcase: only from the merchant's order-location export.
  // Not a real-time latest-order feed; cycle entries independently of the WebGL globe.
  const label=box.closest('.lume-global-journey')?.querySelector('[data-last-order-label]');
  const labelRotator=window.LumeDestinationRotator;
  if(labelRotator&&label)labelRotator.attach(label);

  const amazonPinsUrl=box.dataset.amazonPins;
  const postalReferenceUrl=box.dataset.postalReference;
  function showAmazonPins(){
    if(!amazonPinsUrl||!postalReferenceUrl)return;
    Promise.all([fetch(amazonPinsUrl).then(r=>{if(!r.ok)throw Error("destinations unavailable");return r.json()}),
      fetch(postalReferenceUrl).then(r=>{if(!r.ok)throw Error("postal reference unavailable");return r.json()})])
    .then(([orders,reference])=>{
      const records=Array.isArray(reference)?reference:(reference.records||reference.data||reference.results||reference.pincodes||reference.entries||[]);
      const rows=Array.isArray(records)?records:(records&&typeof records==="object"?Object.values(records):[]);
      const lookup=new Map();
      rows.forEach(item=>{
        if(!item||typeof item!=="object")return;
        const pin=String(item.pincode||item.pin||item.postalCode||item.postal_code||item.code||"");
        const lat=Number(item.latitude??item.lat);
        const lon=Number(item.longitude??item.lng??item.lon);
        if(/^\d{6}$/.test(pin)&&Number.isFinite(lat)&&Number.isFinite(lon)&&lat>=6&&lat<=38&&lon>=68&&lon<=98)lookup.set(pin,{lat,lon,state:String(item.state||"")});
      });
      const normalize=s=>String(s||"").toLowerCase().replace(/[^a-z]/g,"");
      const selected=[];
      let unresolved=0;
      orders.forEach(([pin,city,state,count])=>{
        const point=lookup.get(String(pin));
        if(!point){unresolved++;return}
        const a=normalize(state),b=normalize(point.state);
        if(b&&a!==b&&!((a==="jammukashmir"||a==="jammuandkashmir")&&(b==="jammukashmir"||b==="jammuandkashmir"))){unresolved++;return}
        selected.push({pin,city,state,count:Number(count)||1,lat:point.lat,lon:point.lon});
      });
      if(!selected.length){box.setAttribute("data-amazon-pin-error","no-geocoded-records");return}
      if(window.LumeDestinationRotator)window.LumeDestinationRotator.attachCoordinates(selected,group,v,T);
      const ball=new T.SphereGeometry(.020,8,6);
      const points=new T.InstancedMesh(ball,new T.MeshBasicMaterial({color:0xd7ff9d,transparent:true,opacity:.85,depthWrite:false}),selected.length);
      const dummy=new T.Object3D();
      selected.forEach((p,i)=>{
        dummy.position.copy(v(p.lat,p.lon,1.67));
        const scale=Math.min(1.7,1+Math.log2(1+p.count)*.14);
        dummy.scale.setScalar(scale);
        dummy.updateMatrix();points.setMatrixAt(i,dummy.matrix);
      });
      points.instanceMatrix.needsUpdate=true;
      group.add(points);
      box.dataset.amazonPinsShown=String(selected.length);
      box.dataset.amazonPinsUnresolved=String(unresolved);
      const stride=Math.max(1,Math.ceil(selected.length/38));
      selected.filter((_,i)=>i%stride===0).forEach(p=>{
        const path=[];
        for(let k=0;k<=25;k++)path.push(arcPoint(p,k/25,1.65));
        const link=new T.Line(new T.BufferGeometry().setFromPoints(path),
          new T.LineBasicMaterial({color:0x7bc4a0,transparent:true,opacity:.28,depthWrite:false}));
        group.add(link);
      });
    }).catch(()=>box.setAttribute("data-amazon-pin-error","coordinate-reference-unavailable"));
  }
  if("IntersectionObserver" in window){
    const pinObserver=new IntersectionObserver(entries=>{if(entries.some(x=>x.isIntersecting)){pinObserver.disconnect();showAmazonPins()}},{rootMargin:"200px"});
    pinObserver.observe(box);
  }else showAmazonPins();
  const textureUrl=box.dataset.texture;
  new T.TextureLoader().load(textureUrl,function(tex){tex.encoding=T.sRGBEncoding;tex.anisotropy=Math.min(renderer.capabilities.getMaxAnisotropy(),8);surface.material.map=tex;surface.material.needsUpdate=true;box.classList.add('ljx-ready')},undefined,function(){box.setAttribute('data-earth-error','texture-unavailable')});
  if(box.dataset.clouds){new T.TextureLoader().load(box.dataset.clouds,function(cloudTex){
      cloudTex.encoding=T.sRGBEncoding;
      const clouds=new T.Mesh(new T.SphereGeometry(1.642,72,54),new T.MeshLambertMaterial({map:cloudTex,transparent:true,opacity:.18,depthWrite:false}));
      group.add(clouds);
    });
  }
  let latAngle=14*Math.PI/180;
  let initialY=-1.42;let dragY=0,pausedUntil=0,down=null;
  const el=renderer.domElement;
  el.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')return;down={x:e.clientX,start:dragY};pausedUntil=Date.now()+4000});
  window.addEventListener('pointerup',function(){down=null});
  el.addEventListener('pointermove',function(e){if(!down)return;dragY=down.start+(e.clientX-down.x)*.006;pausedUntil=Date.now()+4000});
  const clock=new T.Clock();
  let active=true,hidden=document.hidden;
  const visibility=()=>{hidden=document.hidden};document.addEventListener('visibilitychange',visibility);
  let observer=null;if('IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{active=entries[0]?.isIntersecting!==false},{rootMargin:'180px'});observer.observe(box)}
  const resize=new ResizeObserver(function(){let width=w(),height=h();camera.aspect=width/height;camera.position.z=width<450?7.8:6.4;camera.updateProjectionMatrix();renderer.setSize(width,height,false)});resize.observe(mount);
  const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function tick(){
    requestAnimationFrame(tick);
    if(hidden||!active)return;
    const t=clock.getElapsedTime();
    const rot=reduced?0:(Date.now()<pausedUntil?0:t*((2*Math.PI)/10));
    group.rotation.set(latAngle,initialY-rot+dragY,0,'XYZ');
    courier.forEach(({moving,d,i,ring})=>{
      const v0=reduced?.83:(t*.075+i*.137)%1;
      moving.position.copy(arcPoint(d,v0,1.648));
      if(ring){const pulse=reduced?1:1+.36*Math.sin(t*2.75);ring.scale.setScalar(pulse);ring.material.opacity=reduced?.8:.28+.55*(.5+.5*Math.sin(t*2.75));}
    });
    renderer.render(scene,camera);
  }tick();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();